<template>
  <Container class="flex-col align-start">
    <h2 style="margin:10px 20px">
      用印审批记录
      <div style="font-size:12px;color:var(--subtext3);font-weight:bold;">
        用印审批和登记记录
      </div>
    </h2>
    <div class="flex-wrap align-center" style="margin:10px 20px;gap:10px;flex-wrap:wrap;">
      <RadioGroup v-model="contentScope" type="button">
        <Radio label="contract">合同类资料</Radio>
        <Radio label="all">全部记录</Radio>
      </RadioGroup>
      <Input
        v-model="searchText"
        search
        clearable
        placeholder="名称 / 项目部门 / 编号 / 人员 / 状态"
        style="width:320px"
        @on-search="noop"
      />
      <Button icon="md-refresh" style="margin-left:10px" @click="getData()"></Button>
      <span style="margin-left:12px;font-size:12px;color:var(--subtext3);align-self:center;">
        共 {{ filteredItems.length }} 条
      </span>
    </div>
    <div style="padding:0 20px;height:calc(100% - 40px);width:100%;">
      <BaseTable ref="table" :columns="cols" :data="filteredItems" :loading="loading" />
    </div>

    <Modal
      v-model="logVisible"
      :title="logTitle"
      width="720"
      footer-hide
      scrollable
      class-name="seal-approval-log-modal"
    >
      <div v-if="logRow" class="seal-log-wrap">
        <div class="seal-log-meta">
          <span>审批编号：{{ logRow.approval_no || '—' }}</span>
          <span>状态：<Tag :color="statusColor(logRow.status)">{{ logRow.status || '—' }}</Tag></span>
          <span>结果：{{ logRow.approval_result || '—' }}</span>
        </div>
        <div v-if="logSteps.length" class="seal-log-steps">
          <div v-for="(s, i) in logSteps" :key="i" class="seal-log-step">
            <div class="seal-log-dot"></div>
            <div class="seal-log-body">
              <div class="seal-log-head">
                <strong>{{ s.actor || '—' }}</strong>
                <span class="seal-log-role">{{ s.role }}</span>
                <span class="seal-log-time">{{ s.time }}</span>
              </div>
              <div class="seal-log-action">{{ s.action || '—' }}</div>
              <div v-if="s.remark" class="seal-log-remark">{{ s.remark }}</div>
            </div>
          </div>
        </div>
        <div v-else class="seal-log-empty">暂无审批记录明细</div>
      </div>
    </Modal>
  </Container>
</template>

<script>
import Container from '@/components/app/container';
import moment from 'moment';

const MOCK_JSON = (process.env.BASE_URL || '/').replace(/\/?$/, '/') + 'contracts-admin-mock/seal-approval-records.json';

export default {
  routerOption: {
    as_default: true,
  },
  components: {Container},
  data() {
    return {
      /** 使用内容：contract=仅合同类资料，all=全部 */
      contentScope: 'all',
      searchText: '',
      loading: false,
      allItems: [],
      logVisible: false,
      logRow: null,
    };
  },
  computed: {
    filteredItems() {
      let list = this.allItems;
      if (this.contentScope === 'contract') {
        list = list.filter((row) => (row.use_type || '').trim() === '合同类资料');
      }
      const q = (this.searchText || '').trim().toLowerCase();
      if (!q) {
        return list;
      }
      return list.filter((row) => {
        const blob = [
          row.name,
          row.partA,
          row.title,
          row.approval_no,
          row.created_by,
          row.checked_by,
          row.status,
          row.approval_result,
          row.dept,
          row.use_type,
          row.remark,
        ].filter(Boolean).join(' ').toLowerCase();
        return blob.includes(q);
      });
    },
    logTitle() {
      if (!this.logRow) {
        return '审批记录';
      }
      const t = (this.logRow.name || '').slice(0, 28);
      return t ? `审批记录 · ${t}` : '审批记录';
    },
    logSteps() {
      if (!this.logRow || !Array.isArray(this.logRow.approval_log)) {
        return [];
      }
      return this.logRow.approval_log;
    },
    cols() {
      const vm = this;
      return [
        {title: '序号', width: 60, type: 'index'},
        {
          title: '用印日期',
          width: 120,
          render(h, {row}) {
            const t = row.signed_at;
            return h('div', {style: 'color:var(--success)'}, t ? moment(t).format('L') : '-');
          },
        },
        {
          title: '使用内容',
          width: 130,
          render(h, {row}) {
            return h('div', {attrs: {title: row.use_type}}, (row.use_type || '-').slice(0, 14) + ((row.use_type || '').length > 14 ? '…' : ''));
          },
        },
        {
          title: '资料 / 标题',
          minWidth: 160,
          key: 'name',
          render(h, {row}) {
            const icon = h('BaseIcon', {props: {icon: 'contract'}, style: 'margin-right:3px;color:var(--primary)'});
            const name = h('span', {attrs: {title: row.name}}, row.name);
            return h('div', {class: 'flex-wrap'}, [icon, name]);
          },
        },
        {
          title: '项目 / 部门',
          width: 200,
          render(h, {row}) {
            return h('span', {attrs: {title: row.partA}}, row.partA);
          },
        },
        {
          title: '审批状态',
          width: 100,
          render(h, {row}) {
            return h('Tag', {props: {color: vm.statusColor(row.status)}}, row.status || '—');
          },
        },
        
        {
          title: '申请人',
          width: 100,
          render(h, {row}) {
            return h('span', row.created_by || '—');
          },
        },
        {
          title: '审批人',
          width: 120,
          render(h, {row}) {
            const t = row.checked_by || '';
            return h('span', {attrs: {title: t}}, t ? (t.length > 12 ? t.slice(0, 12) + '…' : t) : '—');
          },
        },
        
      ];
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    noop() {},
    statusColor(status) {
      const s = status || '';
      if (s.includes('已结束')) {
        return 'success';
      }
      if (s.includes('审批中')) {
        return 'blue';
      }
      if (s.includes('终止')) {
        return 'error';
      }
      return 'default';
    },
    openLog(row) {
      this.logRow = row;
      this.logVisible = true;
    },
    getData() {
      this.loading = true;
      fetch(MOCK_JSON)
        .then((r) => {
          if (!r.ok) {
            throw new Error(r.statusText || String(r.status));
          }
          return r.json();
        })
        .then((payload) => {
          const list = Array.isArray(payload.items) ? payload.items : [];
          this.allItems = list;
        })
        .catch((e) => {
          this.Error(e);
          this.allItems = [];
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
        });
    },
  },
};
</script>

<style lang="less">
.seal-log-wrap {
  font-size: 13px;
}
.seal-log-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
  color: var(--subtext2);
}
.seal-log-steps {
  position: relative;
  padding-left: 8px;
}
.seal-log-step {
  position: relative;
  padding-left: 22px;
  padding-bottom: 16px;
}
.seal-log-step:not(:last-child)::before {
  content: '';
  position: absolute;
  left: 3px;
  top: 14px;
  bottom: 0;
  width: 2px;
  background: var(--border);
}
.seal-log-step:last-child {
  padding-bottom: 0;
}
.seal-log-dot {
  position: absolute;
  left: 0;
  top: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--primary);
  z-index: 1;
}
.seal-log-body {
  position: relative;
}
.seal-log-head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px 10px;
}
.seal-log-role {
  font-size: 12px;
  color: var(--subtext3);
}
.seal-log-time {
  font-size: 12px;
  color: var(--subtext2);
  margin-left: auto;
}
.seal-log-action {
  margin-top: 4px;
  color: var(--text2);
}
.seal-log-remark {
  margin-top: 6px;
  padding: 8px 10px;
  background: var(--bg3);
  border-radius: 4px;
  white-space: pre-wrap;
  color: var(--subtext2);
  font-size: 12px;
}
.seal-log-empty {
  color: var(--subtext3);
  text-align: center;
  padding: 24px;
}
</style>
